import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableComponent} from './components/table/table.component';
import {
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule, NbLayoutModule,
  NbListModule,
  NbMenuModule, NbRadioModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTooltipModule,
} from '@nebular/theme';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {NgSelectModule} from '@ng-select/ng-select';
import {MatMenuModule} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {NgxFileDropModule} from 'ngx-file-drop';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatListModule} from '@angular/material/list';
import {FeatureToggleModule} from "ngx-feature-toggle";
import {DroppableModule} from "./modules/droppable/droppable.module";
import {ManagementState} from '../main/modules/management/state/management.state';
import {ManagementFacade} from '../main/modules/management/facade/management.facade';
import {ManagementApi} from '../main/modules/management/api/management.api';
import {DataSourcePreviewFacade} from './components/data-source-preview/facade/data-source-preview.facade';
import {DataSourceApi} from '../data-source/api/data-source.api';
import {DataSourceFacade} from '../data-source/facade/data-source.facade';
import {DataSourceState} from '../data-source/state/data-source.state';
import {DataModuleColumnService} from '../data-source/services/dataModuleColumn.service';
import {DashboardCardComponent} from './components/dashboard-card/dashboard-card.component';
import {SearchResultComponent} from './components/search-result/search-result.component';
import {PaginationComponent} from './components/pagination/pagination.component';
import {IconsComponent} from './components/icons/icons.component';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {DeleteDialogComponent} from './components/delete-dialog/delete-dialog.component';
import {EditDialogComponent} from './components/edit-dialog/edit-dialog.component';
import {RouterModule} from '@angular/router';
import {DatePickerComponent} from './components/date-picker/date-picker.component';
import {WorkSpaceDialogComponent} from './components/work-space-dialog/work-space-dialog.component';
import {DashboardGroupPermissionComponent}
from './components/permissions/components/dashboard-group-permission/dashboard-group-permission.component';
import {DashboardPermissionsComponent}
from './components/permissions/components/dashboard-permissions/dashboard-permissions.component';
import {DataSourcePermissionComponent}
from './components/permissions/components/data-source-permission/data-source-permission.component';
import {ProfileComponent} from './components/profile/profile.component';
import {DeleteAccessComponent} from
'./components/permissions/components/dialogs/delete-access/delete-access.component';
import {ToastrNotifictionComponent} from './components/toastr-notifiction/toastr-notifiction.component';
import {LinearNotificationComponent} from './components/linear-notification/linear-notification.component';
import {UniversalSearchComponent} from './components/universal-search/universal-search.component';
import {WebServiceCreateComponent} from
'./components/data-source-preview/components/web-service-create/web-service-create.component';
import {ManagementDataBaseComponent} from
'./components/data-source-preview/components/management-data-base/management-data-base.component';
import {PreviewTableComponent} from './components/data-source-preview/components/preview-table/preview-table.component';
import {CreateDataSourceComponent} from
'./components/data-source-preview/components/create-data-source/create-data-source.component';
import {CreateDashboardComponent} from
'./components/data-source-preview/components/create-dashboard/create-dashboard.component';
import {LoadingDialogComponent} from
'./components/data-source-preview/components/loading-dialog/loading-dialog.component';
import {
  ChartPermissionComponent,
} from './components/permissions/components/chart-permission/chart-permission.component';
import {Error404Component} from './components/error-pages/error404/error404.component';
import {Error403Component} from './components/error-pages/error403/error403.component';
import {Error500Component} from './components/error-pages/error500/error500.component';
import {Error502Component} from './components/error-pages/error502/error502.component';
import {DaxHelpDialogComponent} from './components/dax-help-dialog/dax-help-dialog.component';
import {PreviewExcelComponent} from './components/data-source-preview/components/preview-excel/preview-excel.component';
import {UserFilterActionComponent} from './components/user-filter-action/user-filter-action.component';
import {SidebarMenuComponent} from './components/sidebar-menu/sidebar-menu.component';
import {CompactedSideBarMenuComponent} from './components/compacted-side-bar-menu/compacted-side-bar-menu.component';
import {SassHelperComponent} from './providers/sass-helper/sass-helper.component';
import {
  DataSourceInDashboardsComponent,
} from './components/data-source-in-dashboards/data-source-in-dashboards.component';
import {TwoFactorAuthenticationComponent}
from './components/two-factor-authentication/two-factor-authentication.component';
import {HelpComponent} from './components/help/help.component';
import {MetaDataBarComponent} from './components/meta-data-bar/meta-data-bar.component';
import {ConnectionFormComponent}
from './components/data-source-preview/components/connection-form/connection-form.component';
import {DaxFormulaBarComponent} from './components/dax-formula-bar/dax-formula-bar.component';
import {MessageDialogComponent} from './components/message-dialog/message-dialog.component';
import {DuplicateDatasourceDialogComponent}
from './components/duplicate-datasource-dialog/duplicate-datasource-dialog.component';
import {ErrorLicenceComponent} from './components/error-pages/error-licence/error-licence.component';
import {StopScheduleDialogComponent} from './components/stop-schedule-dialog/stop-schedule-dialog.component';
import {DataUpdateSettingsComponent} from "./components/data-source-preview/components/data-update-settings/data-update-settings.component";
import {IpErrorComponent} from "./components/error-pages/ip-error/ip-error.component";
import {ErrorUploadingDataSourceModalComponent} from './components/data-source-preview/components/error-uploading-data-source-modal/error-uploading-data-source-modal.component';
import {PublicDeleteComponent} from './components/public-delete/public-delete.component';
import {DisconnectionComponent} from './components/error-pages/disconnection/disconnection.component';
import {SsoErrorComponent} from "./components/error-pages/sso-error/sso-error.component";
import {FeatureToggleComponent} from "./components/feature-toggle/feature-toggle.component";
import {SortButtonComponent} from "./components/sort-button/sort-button.component";

import {TartAnimationDirective} from './directives/tart-animation.directive';
import {TartIconColorDirective} from './directives/tart-icon-color.directive';
import {TartEllipsisTooltipDirective} from './directives/tart-ellipsis-tooltip.directive';
import {TartTooltipLinkDirective} from './directives/tart-tooltip-link.directive';
import {ClickStopPropagationDirective} from './directives/click-stop-propagation/click-stop-propagation.directive';
import {LangClassSwitcherDirective} from './directives/lang-class-switcher.directive';
import {DynamicImageDirective, HiddenDirective} from "./directives";
import {DigitOnlyDirective} from './directives/only-digit.directive';
import {EmailOnlyDirective} from './directives/only-email.direcive';
import {HideInProductionDirective} from './directives/hide-in-production.directive';
import {DataCyDirective} from './directives/data-testid.directive';

import {PersianNumberPipe} from './pipes/persian-number.pipe';
import {BlankValuePipe} from "./pipes/blank-value.pipe";
import {TicksToDatePipe} from './pipes/ticks-to-date.pipe';
import {NumberFormatPipe} from './pipes/number-format.pipe';
import {TicksToTimePipe} from './pipes/ticks-to-time.pipe';
import {DateAgoPipe} from './pipes/date-ago.pipe';
import {SecondsToTimePipe} from './pipes/seconds-to-time.pipe';
import {SafePipe} from './pipes/safe/safe.pipe';
import {TruncateHtmlPipe} from './pipes/truncate-html/truncate-html.pipe';
import {ToLinkPipe} from './pipes/to-link/to-link.pipe';
import {ToPersianCharsPipe} from './pipes/to-persian-chars.pipe';
import {FilterPipe} from './pipes/filter/filter.pipe';
import {IsPersianCharsPipe} from './pipes/is-persian-chars.pipe';
import {ToImagePipe} from './pipes/to-image/to-image.pipe';
import {BidiFixPipe} from './pipes/bidi-fix.pipe';
import {DataSizePipe} from './pipes/data-source-size.pipe';
import {DashboardFacade} from "../dashboard/facade/dashboard.facade";
import {DashboardApi} from "../dashboard/api/dashboard.api";
import {ImportDashboardDatasourcesModalComponent} from "../dashboard/components/dialogs/import-dashboard-datasources-modal/import-dashboard-datasources-modal.component";
import {ImportDashboardActivationModalComponent} from "../dashboard/components/dialogs/import-dashboard-activation-modal/import-dashboard-activation-modal.component";
import {DashboardState} from "../dashboard/state/dashboard.state";
import { GridsterContainerComponent } from './components/gridster-container/gridster-container.component';
import { GridsterModule } from 'angular-gridster2';
import {CleanRichTextPipe} from "./pipes";

const MATERIAL_MODULES = [
  MatExpansionModule,
  MatListModule,
];

const PIPES = [
  SafePipe,
  TruncateHtmlPipe,
  ToLinkPipe,
  ToPersianCharsPipe,
  FilterPipe,
  IsPersianCharsPipe,
  ToImagePipe,
  BlankValuePipe,
  BidiFixPipe,
  TicksToTimePipe,
  SecondsToTimePipe,
  PersianNumberPipe,
  TicksToDatePipe,
  NumberFormatPipe,
  DateAgoPipe,
  DataSizePipe,
  CleanRichTextPipe
];

const DIRECTIVES = [
  ClickStopPropagationDirective,
  LangClassSwitcherDirective,
  TartAnimationDirective,
  TartEllipsisTooltipDirective,
  TartTooltipLinkDirective,
  DigitOnlyDirective,
  EmailOnlyDirective,
  DataCyDirective,
  HideInProductionDirective,
  TartIconColorDirective,
  HiddenDirective
];

const COMPONENTS = [
  TableComponent,
  DashboardCardComponent,
  SearchResultComponent,
  PaginationComponent,
  IconsComponent,
  NotificationsComponent,
  DeleteDialogComponent,
  EditDialogComponent,
  DatePickerComponent,
  WorkSpaceDialogComponent,
  DashboardGroupPermissionComponent,
  DashboardPermissionsComponent,
  DataSourcePermissionComponent,
  ProfileComponent,
  DeleteAccessComponent,
  ToastrNotifictionComponent,
  LinearNotificationComponent,
  UniversalSearchComponent,
  WebServiceCreateComponent,
  ManagementDataBaseComponent,
  DataUpdateSettingsComponent,
  PreviewTableComponent,
  CreateDataSourceComponent,
  CreateDashboardComponent,
  LoadingDialogComponent,
  ChartPermissionComponent,
  Error404Component,
  Error403Component,
  Error500Component,
  Error502Component,
  DisconnectionComponent,
  IpErrorComponent,
  SsoErrorComponent,
  ErrorLicenceComponent,
  MessageDialogComponent,
  StopScheduleDialogComponent,
  DaxHelpDialogComponent,
  PreviewExcelComponent,
  UserFilterActionComponent,
  SidebarMenuComponent,
  CompactedSideBarMenuComponent,
  SassHelperComponent,
  TwoFactorAuthenticationComponent,
  HelpComponent,
  MetaDataBarComponent,
  ConnectionFormComponent,
  DataSourceInDashboardsComponent,
  DaxFormulaBarComponent,
  DuplicateDatasourceDialogComponent,
  PublicDeleteComponent,
  ImportDashboardActivationModalComponent,
  ImportDashboardDatasourcesModalComponent,
  SortButtonComponent,
  GridsterContainerComponent
];

const NEBULAR_MODULES = [
  NbCardModule,
  NbIconModule,
  NbCheckboxModule,
  NbSelectModule,
  NbContextMenuModule,
  NbSidebarModule,
  NbMenuModule,
  NbButtonModule,
  NbDialogModule.forChild(),
  NbTabsetModule,
  NbTooltipModule,
  NgSelectModule,
  NbSpinnerModule,
  NbListModule,
  NbAutocompleteModule,
  NbRadioModule,
  NbLayoutModule,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...PIPES,
    ...DIRECTIVES,
    ErrorUploadingDataSourceModalComponent,
  ],
  imports: [
    CommonModule,
    GridsterModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NbInputModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    NgxSkeletonLoaderModule,
    NgxFileDropModule,
    DroppableModule,
    ...NEBULAR_MODULES,
    ...MATERIAL_MODULES,
    DynamicImageDirective,
    FeatureToggleComponent
  ],
  exports: [
    ...COMPONENTS,
    ...PIPES,
    ...DIRECTIVES,
    TranslateModule,
    DynamicImageDirective,
    FeatureToggleModule,
    FeatureToggleComponent
  ],
  providers: [
    ManagementApi,
    ManagementFacade,
    ManagementState,
    DataSourceApi,
    DataSourceFacade,
    DataSourceState,
    DataModuleColumnService,
    DashboardFacade,
    DashboardApi,
    DashboardState,
    {provide: 'DataSourcePreview', useClass: DataSourcePreviewFacade},
  ],
  // entryComponents: [ToastrNotifictionComponent],
})
export class SharedModule {
}
